import s from './index.module.css'

export const Wpapper = ({children}) => {
    return(
        <div className={s.wpapper}>
            {children}
        </div>
    )
}